
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaginationItem',
  props: {
    type: String,
    pageNum: [Number, String],
    disabled: Boolean,
    active: Boolean,
    readOnly: Boolean,
  },
  emits: ['click'],
  setup(props, { emit }) {
    const onClick = () => {
      emit('click');
    };

    return {
      onClick,
    };
  },
});
